
{
  "missing-location": "Pleae select a location for the menu import.",
  "woflow-not-initialized": "Failed to initialize the menu import tool. Please contact support."
}
